import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useTranslation } from 'react-i18next';
import './index.css';

const MAP_CENTER = { lat: 56.95489545327712, lng: 24.137682320826176 };

const HOURS = [
  { dayKey: 'weekDays.monday', hours: '08:00 – 20:00' },
  { dayKey: 'weekDays.tuesday', hours: '08:00 – 20:00' },
  { dayKey: 'weekDays.wednesday', hours: '08:00 – 20:00' },
  { dayKey: 'weekDays.thursday', hours: '08:00 – 20:00' },
  { dayKey: 'weekDays.friday', hours: '08:00 – 20:00' },
  { dayKey: 'weekDays.saturday', hours: '09:00 – 15:00' },
  { dayKey: 'weekDays.sunday', hours: null },
];

export const Contacts = () => {
  const { t } = useTranslation();

  return (
    <div className="contacts-page">
      <div className="contacts-header">
        <h1 className="contacts-title">{t('contacts.contactCall')}</h1>
        <p className="contacts-subtitle">{t('contacts.contactSub')}</p>
        <div className="contacts-title-divider" />
      </div>

      <div className="contact-cards">
        <a
          href="https://maps.google.com/?q=Matīsa+iela+46+Rīga+Latvija"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-card"
        >
          <PlaceOutlinedIcon sx={{ fontSize: 36 }} />
          <div>
            <p className="contact-card-label">{t('contacts.address')}</p>
            <p className="contact-card-value">Matīsa iela 46, Rīga, LV-1009</p>
          </div>
        </a>

        <a href="tel:+37126409932" className="contact-card">
          <PhoneIphoneOutlinedIcon sx={{ fontSize: 36 }} />
          <div>
            <p className="contact-card-label">{t('contacts.phone')}</p>
            <p className="contact-card-value">+371 26 409 932</p>
          </div>
        </a>

        <a href="mailto:info@rigadentique.lv" className="contact-card">
          <MailOutlinedIcon sx={{ fontSize: 36 }} />
          <div>
            <p className="contact-card-label">{t('contacts.email')}</p>
            <p className="contact-card-value">info@rigadentique.lv</p>
          </div>
        </a>
      </div>

      <div className="contacts-map">
        <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ''}
        >
          <GoogleMap
            mapContainerClassName="google-map-container"
            center={MAP_CENTER}
            zoom={15}
          >
            <Marker position={MAP_CENTER} />
          </GoogleMap>
        </LoadScript>
      </div>

      <div className="contacts-bottom">
        <div className="working-hours-block">
          <h2 className="block-title">{t('contacts.workingHours')}</h2>
          <p className="block-note">{t('contacts.workingHoursSubtitle')}</p>
          <div className="hours-list">
            {HOURS.map(({ dayKey, hours }) => (
              <div key={dayKey} className="hours-row">
                <span>{t(dayKey)}</span>
                <span className="hours-value">
                  {hours ?? t('contacts.byAppointment')}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="socials-block">
          <h2 className="block-title">{t('contacts.socials')}</h2>
          <div className="social-links">
            <a
              href="https://www.instagram.com/rigadentique"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
            >
              <InstagramIcon sx={{ fontSize: 28 }} />
              <span>@rigadentique</span>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61563532634999"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Facebook"
            >
              <FacebookIcon sx={{ fontSize: 28 }} />
              <span>Riga Dentique</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
